import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    IconButton,
    Divider,
    Box,
    TextField
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

const DashEmbalagemDiaDialog = ({ open, onClose, dados, produtoSelecionado, setProdutoSelecionado, produtoDescricaoSelecionado, setProdutoDescricaoSelecionado }) => {

    const theme = useTheme();

    const formatarValor = (valor) => {
        return new Intl.NumberFormat('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(valor);
    };

    const formatarValorSemDecimal = (valor) => {
        return new Intl.NumberFormat('pt-BR', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(valor);
    };

    const totalQtde = dados
        .filter(d =>
            (produtoSelecionado ? d.stProdutoCodigo.toLowerCase().includes(produtoSelecionado.toLowerCase()) : true) &&
            (produtoDescricaoSelecionado ? d.ProdutoDescricao.toLowerCase().includes(produtoDescricaoSelecionado.toLowerCase()) : true)
        ).reduce((acc, item) => acc + (Number(item.qtde) || 0), 0);

    const totalPeso = dados
        .filter(d =>
            (produtoSelecionado ? d.stProdutoCodigo.toLowerCase().includes(produtoSelecionado.toLowerCase()) : true) &&
            (produtoDescricaoSelecionado ? d.ProdutoDescricao.toLowerCase().includes(produtoDescricaoSelecionado.toLowerCase()) : true)
        ).reduce((acc, item) => acc + (Number(item.ProdutoPesoBruto) || 0), 0);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={false}
            fullWidth
            PaperProps={{
                sx: {
                    width: '100vw',
                    //height: '90vh',
                    borderRadius: 3,
                    backgroundColor: '#1d1d1d',
                    boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.5)'
                }
            }}
        >
            {/* Título com Ícone */}
            <DialogTitle
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    backgroundColor: theme.palette.primary.main,
                    color: '#fff',
                    borderTopLeftRadius: 12,
                    borderTopRightRadius: 12
                }}
            >
                <Box display="flex" alignItems="center">
                    <TrendingUpIcon sx={{ marginRight: 1 }} />
                    <Typography variant="h6">📊 Detalhes de Embalagem do Dia</Typography>
                </Box>
                <IconButton onClick={onClose} sx={{ color: '#fff' }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ backgroundColor: '#1d1d1d', p: 3 }}>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
                    <TextField
                        fullWidth
                        label="Código do Produto"
                        variant="outlined"
                        value={produtoSelecionado}
                        onChange={(e) => setProdutoSelecionado(e.target.value)}
                        sx={{
                            mb: 2,
                            backgroundColor: '#2d2d2d',
                            color: '#fff',
                            borderRadius: 1,
                            '& .MuiInputBase-input': { color: '#fff' },
                            '& .MuiInputLabel-root': { color: '#ccc' },
                            '& .MuiInputLabel-root.Mui-focused': { color: '#fff' },
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': { borderColor: '#555' },
                                '&:hover fieldset': { borderColor: '#888' },
                                '&.Mui-focused fieldset': { borderColor: '#fff' }
                            },
                            marginTop: 2
                        }}
                    />
                    <TextField
                        fullWidth
                        label="Produto"
                        variant="outlined"
                        value={produtoDescricaoSelecionado}
                        onChange={(e) => setProdutoDescricaoSelecionado(e.target.value)}
                        sx={{
                            mb: 2,
                            backgroundColor: '#2d2d2d',
                            color: '#fff',
                            borderRadius: 1,
                            '& .MuiInputBase-input': { color: '#fff' },
                            '& .MuiInputLabel-root': { color: '#ccc' },
                            '& .MuiInputLabel-root.Mui-focused': { color: '#fff' },
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': { borderColor: '#555' },
                                '&:hover fieldset': { borderColor: '#888' },
                                '&.Mui-focused fieldset': { borderColor: '#fff' }
                            },
                            marginTop: 2
                        }}
                    />
                </div>

                <Divider sx={{ mb: 2, backgroundColor: '#444' }} />

                <Box sx={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr style={{ backgroundColor: theme.palette.primary.main, color: '#fff' }}>
                                <th style={{ padding: '10px', textAlign: 'left' }}>Empresa</th>
                                <th style={{ padding: '10px', textAlign: 'left' }}>Nro. Lote</th>
                                <th style={{ padding: '10px', textAlign: 'left' }}>Dt. Programado</th>
                                <th style={{ padding: '10px', textAlign: 'left' }}>Cód. Produto</th>
                                <th style={{ padding: '10px', textAlign: 'left' }}>Produto</th>
                                <th style={{ padding: '10px', textAlign: 'left' }}>Revestimento</th>
                                <th style={{ padding: '10px', textAlign: 'right' }}>Qtde</th>
                                <th style={{ padding: '10px', textAlign: 'right' }}>Peso</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dados.filter(d =>
                                (produtoSelecionado ? d.stProdutoCodigo.toLowerCase().includes(produtoSelecionado.toLowerCase()) : true) &&
                                (produtoDescricaoSelecionado ? d.ProdutoDescricao.toLowerCase().includes(produtoDescricaoSelecionado.toLowerCase()) : true)
                            ).map((item, index) => (
                                <tr
                                    key={index}
                                    style={{
                                        backgroundColor: index % 2 === 0 ? '#2d2d2d' : '#1d1d1d',
                                        color: '#fff',
                                        transition: 'background-color 0.3s'
                                    }}
                                    onMouseEnter={e => e.currentTarget.style.backgroundColor = '#333'}
                                    onMouseLeave={e => e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#2d2d2d' : '#1d1d1d'}
                                >
                                    <td style={{ padding: '10px' }}>{item.EmpresaFabricacaoId}</td>
                                    <td style={{ padding: '10px' }}>{item.LoteProducaoId}</td>
                                    <td style={{ padding: '10px', textAlign: 'left' }}>
                                        {new Date(item.LoteProducaoDtProgramado).toLocaleDateString('pt-BR')}
                                    </td>
                                    <td style={{ padding: '10px' }}>{item.stProdutoCodigo}</td>
                                    <td style={{ padding: '10px' }}>{item.ProdutoDescricao}</td>
                                    <td style={{ padding: '10px' }}>{item.RevestimentoDescricao}</td>
                                    <td style={{ padding: '10px', textAlign: 'right' }}>
                                        {formatarValorSemDecimal(item.qtde)}
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'right' }}>
                                        {formatarValor(item.ProdutoPesoBruto)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr style={{ backgroundColor: '#333', color: '#fff' }}>
                                <td colSpan="6"></td>
                                <td style={{ padding: '10px', textAlign: 'right', fontWeight: 'bold', color: '#4caf50' }}>
                                    {formatarValorSemDecimal(totalQtde)}
                                </td>
                                <td style={{ padding: '10px', textAlign: 'right', fontWeight: 'bold', color: '#4caf50' }}>
                                    {formatarValor(totalPeso)}
                                </td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                </Box>
            </DialogContent>

            {/* Botão Fechar */}
            <DialogActions sx={{ backgroundColor: '#1d1d1d', p: 2 }}>
                <Button
                    onClick={onClose}
                    variant="contained"
                    color="error"
                    startIcon={<CloseIcon />}
                    sx={{ fontWeight: 'bold', borderRadius: 2 }}
                >
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DashEmbalagemDiaDialog;
